export const commentForm = () => {

    jQuery(function ($) {
        var commentform=$('#commentform');
        if(commentform.length > 0) {
            commentform.prepend('<div id="wdpajax-info" ></div>');
            var infodiv = $('#wdpajax-info');
            var commentTextarea = commentform.find('textarea[name=comment]');
            var authorTextarea = commentform.find('input[name=author]');
            var emailTextarea = commentform.find('input[name=email]');
            commentform.validate({
                submitHandler: function (form) {
                    var formdata = commentform.serialize();
                    infodiv.html('<p>Processing...</p>');
                    var formurl = commentform.attr('action');
                    $.ajax({
                        type: 'post',
                        url: formurl,
                        data: formdata,
                        error: function (XMLHttpRequest, textStatus, errorThrown) {
                            infodiv.html('<p class="wdpajax-error" >You might have left one of the fields blank.</p>');
                        },
                        success: function (data, textStatus) {
                            if (data == "success") {
                                infodiv.html('<p class="wdpajax-success" >Thanks for your comment. We appreciate your response.</p>');
                                commentTextarea.val('');
                            } else {
                                if(authorTextarea.length > 0) {
                                    setvalidator(authorTextarea);
                                    setvalidator(emailTextarea);
                                }
                                setvalidator(commentTextarea);
                                infodiv.html('<p class="wdpajax-error" >Error in processing your form.</p>');
                            }
                        }
                    });
                }
            });

            commentTextarea.on('input', function(e){
                setvalidator(commentTextarea);
            });

            if(authorTextarea.length > 0){

                authorTextarea.on('input', function(e){
                    setvalidator(authorTextarea);
                });

                emailTextarea.on('input', function(e){
                    checkValidEmail(emailTextarea);
                });
            }
        }
    });

    function setvalidator(el){
        el.val() ? el[0].setCustomValidity("") : el[0].setCustomValidity("Please fill out this field.");
        el[0].reportValidity();
    }

    function checkValidEmail(el){
        isEmailValid(el.val()) ? el[0].setCustomValidity("") : el[0].setCustomValidity("Please enter valid email.");
        el[0].reportValidity();
    }

    function isEmailValid(emailAddress) {
        var email = document.createElement("input");
        email.type = "email";
        email.value = emailAddress;
        return email.checkValidity();
    }

}
